module.exports = __webpack_public_path__ + "static/img/vip.89102dc9.jpg";